import React from 'react';
import SEO from '../../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './PaidAdsHealthcare.css';

const PaidAdsHealthcare = () => {
    return (
        <div className="industry-service-page">
            <SEO 
                title="Paid Ads Healthcare Services | Digi Network" 
                description="Learn more about our Paid Ads Healthcare services to grow your business online with Digi Network." 
                canonical="/industries/healthcare/services/paidadshealthcare" 
            />

            {/* Hero Section */}
            <section className="industry-service-hero">
                <div className="industry-service-hero-bg"></div>
                <div className="container">

                        
                    <div className="industry-service-hero-content">
                        <div className="label">PAID ADVERTISING</div>
                        <h1>Paid Advertising for Healthcare Practices</h1>
                        <p className="industry-service-hero-description">Drive qualified patient appointments with HIPAA-compliant advertising campaigns across Google, Facebook, and other platforms. Our healthcare-focused paid advertising helps medical practices attract the right patients and grow their practice efficiently.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free Ad Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* Stats Section */}
            <section className="seo-stats">
                <div className="container">
                    <div className="stats-grid">
                        <div className="stat-card">
                            <div className="stat-number">5x</div>
                            <div className="stat-label">Average ROAS</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">40%</div>
                            <div className="stat-label">Lower Cost Per Click</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">200%</div>
                            <div className="stat-label">Conversion Rate Boost</div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Campaign Monitoring</div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Healthcare Paid Ads Services */}
            <section className="industry-service-details">
                <div className="container">
                    <h2>Healthcare Paid Advertising Services</h2>
                    <p>HIPAA-compliant advertising strategies designed specifically for healthcare practices</p>
                    
                    <div className="service-features-grid">
                        <div className="feature-card">
                            
                            <h3>Google Ads for Healthcare</h3>
                            <p>Target high-intent medical searches with Google Ads campaigns optimized for patient acquisition.</p>
                            <ul>
                                <li>Medical keyword targeting</li>
                                <li>Local search campaigns</li>
                                <li>Display advertising</li>
                                <li>YouTube video ads</li>
                                <li>Google Shopping for medical supplies</li>
                                <li>Smart bidding optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Facebook & Instagram Healthcare Ads</h3>
                            <p>Reach patients on social media with compliant advertising campaigns that build trust and drive appointments.</p>
                            <ul>
                                <li>HIPAA-compliant ad creatives</li>
                                <li>Demographic targeting</li>
                                <li>Interest-based campaigns</li>
                                <li>Video advertising</li>
                                <li>Carousel ads for services</li>
                                <li>Lead generation forms</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>HIPAA-Compliant Landing Pages</h3>
                            <p>Create secure, compliant landing pages that convert visitors into patients while protecting privacy.</p>
                            <ul>
                                <li>Privacy policy compliance</li>
                                <li>Secure contact forms</li>
                                <li>Appointment booking integration</li>
                                <li>Mobile-responsive design</li>
                                <li>Trust signals and credentials</li>
                                <li>Conversion optimization</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Patient Acquisition Campaigns</h3>
                            <p>Target specific patient demographics and medical conditions with precision advertising campaigns.</p>
                            <ul>
                                <li>Condition-specific targeting</li>
                                <li>Age and gender demographics</li>
                                <li>Geographic targeting</li>
                                <li>Insurance-based campaigns</li>
                                <li>Seasonal health campaigns</li>
                                <li>Preventive care promotions</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Retargeting Strategies</h3>
                            <p>Re-engage website visitors and previous patients with strategic retargeting campaigns.</p>
                            <ul>
                                <li>Website visitor retargeting</li>
                                <li>Appointment reminder campaigns</li>
                                <li>Follow-up care promotions</li>
                                <li>Cross-platform retargeting</li>
                                <li>Email list retargeting</li>
                                <li>Lookalike audience campaigns</li>
                            </ul>
                        </div>

                        <div className="feature-card">
                            
                            <h3>Conversion Tracking & Optimization</h3>
                            <p>Track patient acquisition and optimize campaigns for better ROI and appointment bookings.</p>
                            <ul>
                                <li>Appointment booking tracking</li>
                                <li>Patient inquiry attribution</li>
                                <li>A/B testing campaigns</li>
                                <li>ROI analysis and reporting</li>
                                <li>Cost per acquisition optimization</li>
                                <li>Monthly performance reports</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* Why Choose Section */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="section-header">
                        <h2>Why Choose Our Paid Advertising Services</h2>
                        <p>Discover what makes our paid advertising services stand out from the competition</p>
                    </div>
                    <div className="why-seo-points">
                        <div className="why-point">
                            <h4>🚀 Instant Results</h4>
                            <p>Start generating leads immediately with campaigns that drive traffic from day one.</p>
                        </div>
                        <div className="why-point">
                            <h4>🎯 Precision Targeting</h4>
                            <p>Reach your exact audience with advanced targeting options and data-driven strategies.</p>
                        </div>
                        <div className="why-point">
                            <h4>💡 Full Transparency</h4>
                            <p>See exactly where your budget goes with detailed reporting and real-time performance tracking.</p>
                        </div>
                        <div className="why-point">
                            <h4>📊 Continuous Optimization</h4>
                            <p>We constantly test and refine campaigns to maximize ROI and lower acquisition costs.</p>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR PROCESS</div>
                        <h2>Our Paid Advertising Process</h2>
                        <p>A proven methodology designed specifically for healthcare businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Research & Planning</h3>
                            <p>Analyze your audience, competitors, and identify the best advertising channels.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Campaign Setup</h3>
                            <p>Create compelling ad copy, design creative assets, and configure targeting.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Launch & Monitor</h3>
                            <p>Launch campaigns and monitor performance metrics in real-time.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Optimize & Scale</h3>
                            <p>Test, refine, and scale successful campaigns for maximum ROI.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* Healthcare Paid Ads Process */}

            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Attract More Patients with Paid Advertising?</h2>
                    <p>Get a free ad audit and discover how we can help you drive more qualified patient appointments.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Your Free Ad Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default PaidAdsHealthcare;
